import { render, staticRenderFns } from "./SortAnswerImage.vue?vue&type=template&id=3f427770&scoped=true&"
import script from "./SortAnswerImage.vue?vue&type=script&lang=ts&"
export * from "./SortAnswerImage.vue?vue&type=script&lang=ts&"
import style0 from "./SortAnswerImage.vue?vue&type=style&index=0&id=3f427770&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f427770",
  null
  
)

export default component.exports